import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import * as cmsServices from "../services/cms.services";
import { toast } from "react-toastify";
import Loader from "../../admin/common/loader";
import dinoLogo from "../../../assets/admin/img/Dino-Land-logo.png";

const ContactUs = () => {
    const [loading, setLoading] = useState(false);

    const validationSchema = Yup.object({
        name: Yup.string().required("Name is required"),
        email: Yup.string().email("Invalid email address").required("Email is required"),
        subject: Yup.string().required("Subject is required"),
        message: Yup.string().required("Message is required"),
    });

    const formik = useFormik({
        initialValues: {
            name: "",
            email: "",
            subject: "",
            message: ""
        },
        validationSchema: validationSchema,
        onSubmit: async (values, { resetForm }) => {
            setLoading(true);
            try {
                const response = await cmsServices.submitContactUs(values);
                if (response.success) {
                    toast.success("Message sent successfully! 🦖", {
                        position: "top-right"
                    });
                    resetForm();
                } else {
                    toast.error(response.message || "Failed to send message", {
                        position: "top-right"
                    });
                }
            } catch (err) {
                console.error("Error submitting contact form:", err);
                toast.error("Something went wrong. Please try again later.", {
                    position: "top-right"
                });
            } finally {
                setLoading(false);
            }
        },
    });

    return (
        <div className="contact-page-container py-5">
            {loading && <Loader />}
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        <div className="text-center mb-4">
                            <Link to="/">
                                <img src={dinoLogo} alt="Dino Land Logo" style={{ width: "120px", cursor: "pointer" }} className="dino-bounce" />
                            </Link>
                        </div>
                        <div className="card shadow-lg border-0 dino-card">
                            <div className="card-body p-4 p-md-5">
                                <h1 className="mb-4 text-center dino-title">Contact Us</h1>
                                <p className="lead mb-4 text-center dino-subtitle">
                                    Have questions? Send us a message and we'll get back to you!
                                </p>
                                <div className="dino-divider mb-5"></div>

                                <form onSubmit={formik.handleSubmit} className="mt-4">
                                    <div className="row">
                                        <div className="col-md-6 mb-4">
                                            <label className="form-label dino-label">Your Name</label>
                                            <input
                                                type="text"
                                                className={`form-control dino-input-styled ${formik.errors.name && formik.touched.name ? 'is-invalid' : ''}`}
                                                placeholder="Enter your name"
                                                name="name"
                                                {...formik.getFieldProps('name')}
                                            />
                                            <span className="text-danger d-flex text-left">
                                                {formik.errors.name && formik.touched.name && formik.errors.name}
                                            </span>
                                        </div>
                                        <div className="col-md-6 mb-4">
                                            <label className="form-label dino-label">Email Address</label>
                                            <input
                                                type="email"
                                                className={`form-control dino-input-styled ${formik.errors.email && formik.touched.email ? 'is-invalid' : ''}`}
                                                placeholder="Enter your email"
                                                name="email"
                                                {...formik.getFieldProps('email')}
                                            />
                                            <span className="text-danger d-flex text-left">
                                                {formik.errors.email && formik.touched.email && formik.errors.email}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="mb-4">
                                        <label className="form-label dino-label">Subject</label>
                                        <input
                                            type="text"
                                            className={`form-control dino-input-styled ${formik.errors.subject && formik.touched.subject ? 'is-invalid' : ''}`}
                                            placeholder="What is this about?"
                                            name="subject"
                                            {...formik.getFieldProps('subject')}
                                        />
                                        <span className="text-danger d-flex text-left">
                                            {formik.errors.subject && formik.touched.subject && formik.errors.subject}
                                        </span>
                                    </div>

                                    <div className="mb-4">
                                        <label className="form-label dino-label">Message</label>
                                        <textarea
                                            className={`form-control dino-textarea-styled ${formik.errors.message && formik.touched.message ? 'is-invalid' : ''}`}
                                            placeholder="Write your message here..."
                                            rows="5"
                                            name="message"
                                            {...formik.getFieldProps('message')}
                                        ></textarea>
                                        <span className="text-danger d-flex text-left">
                                            {formik.errors.message && formik.touched.message && formik.errors.message}
                                        </span>
                                    </div>

                                    <div className="text-center mt-5">
                                        <button type="submit" className="btn btn-submit-dino-styled px-5 py-2 fw-bold">
                                            Send Message 🦖
                                        </button>
                                    </div>

                                    <div className="text-center mt-4">
                                        <Link to="/" className="text-decoration-none dino-back-link">
                                            ← Back to Home
                                        </Link>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Fredoka+One&display=swap');

                .contact-page-container {
                    background: linear-gradient(135deg, #68e1fd 0%, #fbd53d 100%);
                    min-height: 100vh;
                    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                }
                .dino-card {
                    border-radius: 2rem;
                    background: rgba(255, 255, 255, 0.95);
                    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1) !important;
                }
                .dino-title {
                    font-family: 'Fredoka One', cursive;
                    color: #36594C;
                    font-size: 2.5rem;
                    letter-spacing: 1px;
                }
                .dino-subtitle {
                    color: #557a6b;
                    font-style: italic;
                    font-size: 1.1rem;
                }
                .dino-divider {
                    height: 4px;
                    background: linear-gradient(90deg, transparent, #68e1fd, #fbd53d, transparent);
                    border-radius: 2px;
                }
                .dino-label {
                    font-weight: 600;
                    color: #36594C;
                    margin-bottom: 0.5rem;
                }
                .dino-input-styled, .dino-textarea-styled {
                    border-radius: 15px !important;
                    border: 2px solid #e0e0e0 !important;
                    padding: 12px 20px !important;
                    transition: all 0.3s ease !important;
                    background-color: white !important;
                }
                .dino-input-styled:focus, .dino-textarea-styled:focus {
                    border-color: #68e1fd !important;
                    box-shadow: 0 0 0 0.2rem rgba(104, 225, 253, 0.25) !important;
                    outline: none !important;
                }
                .dino-input-styled.is-invalid, .dino-textarea-styled.is-invalid {
                    border-color: #dc3545 !important;
                }
                .btn-submit-dino-styled {
                    background: linear-gradient(135deg, #fc6767, #ec008c);
                    color: #fff;
                    border: 0;
                    border-radius: 50px;
                    transition: all 0.3s ease;
                    text-transform: uppercase;
                    letter-spacing: 1px;
                    font-size: 1.1rem;
                }
                .btn-submit-dino-styled:hover {
                    transform: scale(1.05);
                    color: #fff;
                    box-shadow: 0 5px 15px rgba(236, 0, 140, 0.4);
                }
                .dino-back-link {
                    color: #557a6b;
                    font-weight: 600;
                    transition: color 0.3s;
                }
                .dino-back-link:hover {
                    color: #36594C;
                }
                .dino-bounce {
                    animation: bounce 2s infinite;
                }
                @keyframes bounce {
                    0%, 100% { transform: translateY(0); }
                    50% { transform: translateY(-15px); }
                }
                @media (max-width: 768px) {
                    .dino-title {
                        font-size: 1.8rem;
                    }
                    .contact-page-container {
                        padding-top: 2rem;
                        padding-bottom: 2rem;
                    }
                }
            `}</style>
        </div>
    );
};

export default ContactUs;
